import { render, staticRenderFns } from "./viewFaq.vue?vue&type=template&id=1470d653"
import script from "./viewFaq.vue?vue&type=script&lang=js"
export * from "./viewFaq.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports